type CountryType = {
  value: string;
  label: string;
};

type GetCountryLabelReturnType = string | null;

export const getCountryLabel = (
  countriesList: CountryType[],
  countryValue: string | null
): GetCountryLabelReturnType => {
  return (
    countriesList.find((country) => country.value === countryValue)?.label ??
    null
  );
};
